import React, { Fragment, useContext } from 'react';
import { useTheme } from 'ThemeContext';
import { AppSettingsContext } from 'AppSettingsContext';
import {
  Wrapper,
  Content,
  Item,
  ItemExternal,
  Icon,
  Title,
  StyledFaIcon
} from './NavMenu.style';
import Widgets from 'components/Widgets';
import WidgetHTML from '../Widgets/WidgetHTML';

function NavMenu({ menu = [], toggle = false }) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);
  return (
    <Wrapper>
      <Content toggle={toggle ? true : undefined}>
        {appSettings.theme === 6
          ? menu && <Widgets widgets={menu} horizontal={true} />
          : menu &&
            menu
              .filter(
                widget =>
                  (widget.widget_id === 3 ||
                    widget.widget_id === 4 ||
                    widget.widget_id === 5) &&
                  widget.data
              )
              .map((widget, key) => (
                <Fragment key={key}>
                  {widget.widget_id === 3 || widget.widget_id === 4 ? (
                    (widget.data.slug &&
                      /(http(s?)):\/\//gi.test(widget.data.slug)) ||
                    (widget.data.link &&
                      /(http(s?)):\/\//gi.test(widget.data.link)) ||
                    (widget.data.url &&
                      /(http(s?)):\/\//gi.test(widget.data.url)) ||
                    widget.data.url_outside ? (
                      <ItemExternal
                        aria-label={` link ${widget.data.slug ||
                          widget.data.link ||
                          widget.data.url ||
                          widget.data.url_outside}`}
                        theme={theme.navMenu.item}
                        href={
                          widget.data.slug ||
                          widget.data.link ||
                          widget.data.url ||
                          widget.data.url_outside
                        }
                        target={
                          widget.data._blank ||
                          widget.data.link_blank ||
                          widget.data.url_blank ||
                          widget.data.url_outside_blank
                            ? '_blank'
                            : '' || widget.data.target || ''
                        }
                        rel={
                          widget.data.nofollow ||
                          widget.data.link_nofollow ||
                          widget.data.url_nofollow ||
                          widget.data.url_outside_nofollow
                            ? 'nofollow'
                            : '' || widget.data.rel || ''
                        }
                        color={widget.data.color}
                      >
                        {widget.data.icon && (
                          <Icon size={widget.data.size}>
                            <StyledFaIcon
                              icon={widget.data.icon.split(',')}
                              theme={theme.navMenu.icon}
                            />
                          </Icon>
                        )}
                        <Title theme={theme.navMenu.title}>
                          {widget.data.title}
                        </Title>
                      </ItemExternal>
                    ) : widget.data.slug || widget.data.link ? (
                      <Item
                        aria-label={` link ${widget.data.slug ||
                          widget.data.link ||
                          widget.data.url ||
                          widget.data.url_outside}`}
                        theme={theme.navMenu.item}
                        smooth
                        to={(() => {
                          let slug;
                          if (widget.data.slug)
                            slug =
                              widget.data.slug[0] === '/' ||
                              widget.data.slug[0] === '#'
                                ? widget.data.slug
                                : `/${widget.data.slug}`;
                          else if (widget.data.link)
                            slug =
                              widget.data.link[0] === '/'
                                ? widget.data.link
                                : `/${widget.data.link}`;
                          else slug = '';

                          return slug;
                        })()}
                        color={widget.data.color}
                      >
                        {widget.data.icon && (
                          <Icon size={widget.data.size}>
                            <StyledFaIcon
                              icon={widget.data.icon.split(',')}
                              theme={theme.navMenu.icon}
                            />
                          </Icon>
                        )}
                        <Title theme={theme.navMenu.title}>
                          {widget.data.title}
                        </Title>
                      </Item>
                    ) : (
                      ''
                    )
                  ) : widget.widget_id === 5 ? (
                    <WidgetHTML data={widget.data.text} />
                  ) : (
                    ''
                  )}
                </Fragment>
              ))}
      </Content>
    </Wrapper>
  );
}

export default NavMenu;
